import http from '~/common/http'
export default {
    getList(params) {
        return http.get('/api/source-group/index', {
            params: params
        });
    },
    create(params) {
        return http.post("/api/source-group/create", params);
    },

    update(params) {
        return http.put("/api/source-group/update", params);
    },

    delete(id) {
        return http.delete("/api/source-group/delete", {
            params: {
                id: id
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/SourceGroup.js